import React from "react";
import { WVUSForm } from "wvus-forms";
import { AccountVerificationForm } from "./components/account-verification-form";
import { CreateSupporterForm } from "./components/create-supporter-form";
import { CreateCiamAccount } from "./components/create-ciam-account";
import { CreateCiamAccountBySupporterNumber } from "./components/create-ciam-account-by-suppoter-number";
import { Confirmation } from "./components/confirmation";
import { MAIN_TITLE, CONFIRMATION_TITLE, ACCOUNT_VERIFICATION_TITLE, EMAIL_FOUND } from "./lib/messages";
import { triggerAnalyticsEvent} from './lib/analytics-helpers';

export default class App extends React.Component {
  constructor() {
    super();
    this.state = {
      CurrentForm: WVUSForm(AccountVerificationForm),
      supporterEmail: "",
      supporterNumber: "",
      title: ACCOUNT_VERIFICATION_TITLE,
      subtitle: "Enter your account number from your welcome letter to get started.",
      currentStep: 1,
      totalSteps: 3,
      isWideCard: false
    };
    this.setForm = this.setForm.bind(this);

    triggerAnalyticsEvent({
      event_label:"AccountVerificationForm"
    }, "account_lookup");
  }

  setForm(form, supporterEmail = "", supporterNumber = "") {
    let FormComponent;

    if (form === "CreateSupporter") {
      FormComponent = WVUSForm(CreateSupporterForm);
      this.setState({
        title: MAIN_TITLE,
        subtitle: "We need a few details to set up your account.",
        currentStep: 2,
        isWideCard: true
      });

      triggerAnalyticsEvent({
        event_label:form,
        page_name: form,
        page_location: 'https://account.worldvision.org/vpv/' + form,
        page_path: 'vpv/' + form,
        page_title: 'VPV ' + form,
      }, "create_account_vpv");
    }
    if (form === "CreateCiamAccount") {
      FormComponent = WVUSForm(CreateCiamAccount);
      this.setState({
        title: EMAIL_FOUND,
        subtitle: "Just one more step. Create a password to finish.",
        currentStep: 2,
        isWideCard: false
      });

      triggerAnalyticsEvent({
        event_label:form,
        page_name: form,
        page_location: 'https://account.worldvision.org/vpv/' + form,
        page_path: 'vpv/' + form,
        page_title: 'VPV ' + form,
      }, "create_account_vpv");

    }
    if (form === "CreateCiamAccountBySupporterNumber") {
      FormComponent = WVUSForm(CreateCiamAccountBySupporterNumber);
      this.setState({
        title: EMAIL_FOUND,
        subtitle: "",
        currentStep: 2,
        isWideCard: false
      });

      triggerAnalyticsEvent({
        event_label:form,
        page_name: form,
        page_location: 'https://account.worldvision.org/vpv/' + form,
        page_path: 'vpv/' + form,
        page_title: 'VPV ' + form,
      }, "create_account_vpv");
    }
    if (form === "Confirmation") {
      FormComponent = Confirmation;
      this.setState({
        title: CONFIRMATION_TITLE,
        subtitle: "",
        currentStep: 3,
        isWideCard: false
      });

      triggerAnalyticsEvent({
        event_label:form,
        supporter_id: supporterNumber,
        email: supporterEmail
      }, "create_account_success");
    }
    this.setState(
      { CurrentForm: FormComponent, supporterEmail, supporterNumber },
      () => {
        const container = document.querySelector(".create-account");
        if (container) container.scrollIntoView({ block: "start" });
      }
    );
  }

  renderTabBar() {
    const { currentStep } = this.state;
    const steps = [
      { number: 1, label: "1. Verify" },
      { number: 2, label: "2. Details" },
      { number: 3, label: "3. Done" }
    ];

    return (
      <ol className="tab-bar" aria-label="Account creation steps">
        {steps.map((step) => {
          const isSelected = step.number === currentStep;
          const isFuture = step.number > currentStep;
          let className = "tab-item";
          if (isSelected) className += " selected";
          if (isFuture) className += " is-disabled";

          return (
            <li
              key={step.number}
              className={className}
              aria-current={isSelected ? "step" : undefined}
            >
              <span className="tab-label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    );
  }

  render() {
    const { CurrentForm, isWideCard } = this.state;
    const cardClass = `create-account__card${isWideCard ? ' create-account__card--wide' : ''}`;
    const titleClass = `create-account__title${
      this.state.title === CONFIRMATION_TITLE ? ' create-account__title--centered' : ''
    }`;

    return (
      <div className="create-account">
        <div className={cardClass}>
          {this.renderTabBar()}
          <h1 className={titleClass}>{this.state.title}</h1>
          {this.state.subtitle && (
            <p className="create-account__subtitle">{this.state.subtitle}</p>
          )}
          <div className="create-account__body">
            <CurrentForm
              setForm={this.setForm}
              supporterEmail={this.state.supporterEmail}
              supporterNumber={this.state.supporterNumber}
            />
          </div>
        </div>
      </div>
    );
  }
}
